export default __webpack_public_path__ + "static/media/penny.ac1fcfae.jpeg";